import { JSONSchemaType } from "ajv"
import util from "../../ts/util"
import { TAuthChangePasswordPutReq, TAuthLoginReq } from "./TAuth"

export const authLoginReqSchema: JSONSchemaType<TAuthLoginReq> = {
  type: "object",
  properties: {
    パスワード: {
      type: "string",
      title: "パスワード",
      minLength: 1,
      errorMessage: util.stringErrorMessage("パスワード", {
        minLength: 1,
      }),
    },
    ユーザーコード: {
      type: "string",
      title: "ユーザーコード",
      minLength: 1,
      maxLength: 4,
      errorMessage: util.stringErrorMessage("ユーザーコード", {
        minLength: 1,
        maxLength: 4,
      }),
    },
  },
  additionalProperties: false,
  required: ["パスワード", "ユーザーコード"],
}

export const authChangePasswordPutReqScheme: JSONSchemaType<TAuthChangePasswordPutReq> =
  {
    type: "object",
    properties: {
      現パスワード: {
        type: "string",
        title: "現パスワード",
        minLength: 1,
        errorMessage: util.stringErrorMessage("現パスワード", {
          minLength: 1,
        }),
      },
      新パスワード: {
        type: "string",
        title: "新パスワード",
        errorMessage: util.stringErrorMessage("新パスワード", {
          minLength: 1,
        }),
      },
    },
    required: ["新パスワード", "現パスワード"],
  }
